import { Directive, forwardRef, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator, ValidatorFn } from '@angular/forms';

@Directive({
  selector: '[remainderValidator][ngModel],[remainderValidator][ngFormControl]',
  providers: [
    {
      multi: true,
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => RemainderValidator),
    },
  ],
})
export class RemainderValidator implements Validator {
  @Input() remainderValidator: ValidatorFn;

  validate(control: AbstractControl) {
    return this.remainderValidator(control);
  }
}
